import { useContext, useMemo } from "react";
import { PORTION_SIZE_MEDIUM, PORTION_SIZE_SMALL } from "../../functions/src/api/constants";
import { PORTIONS_PATH } from "../../functions/src/admin/paths";
import type { Portions } from "../../functions/src/types";
import { useStrings } from "../common-strings";
import { langContext } from "./Lang";
import { useDatabaseVal } from "./firebaseHooks";

export type PortionSizeLabels = { small: string; medium: string; large: string };

/** Same mapping as day orders (`AdminOrders` `Meal` component). */
export function getPortionSizeLabel(portionSize: number, labels: PortionSizeLabels): string {
    if (portionSize === PORTION_SIZE_SMALL) return labels.small;
    if (portionSize === PORTION_SIZE_MEDIUM) return labels.medium;
    return labels.large;
}

/**
 * Localized small / medium / large labels for portion UI (meals popup, etc.).
 * Uses school `portions` names for the active language when set; otherwise `commonStrings` size labels.
 */
export function usePortionSizeLabels(): PortionSizeLabels {
    const portionsData = useDatabaseVal<Portions>(PORTIONS_PATH)[0];
    const commonStrings = useStrings();
    const [lang] = useContext(langContext);

    return useMemo(
        () => ({
            small: portionsData?.nameSmall?.[lang] || commonStrings.small,
            medium: portionsData?.nameMedium?.[lang] || commonStrings.medium,
            large: portionsData?.nameLarge?.[lang] || commonStrings.large,
        }),
        [portionsData, lang, commonStrings.small, commonStrings.medium, commonStrings.large],
    );
}